export const NAV_ACTIVE_ITEMS_CHANGE = 'NAV_ACTIVE_ITEMS_CHANGE';
export const NAV_MENU_CHANGE = 'NAV_MENU_CHANGE';
export const NAV_ROUTES_CHANGE = 'NAV_ROUTES_CHANGE';